import { action } from '@reatom/framework'

import { WeakRegistry } from '@blade/std-lib'
import { LimitOrderId } from '@root/entities/limit-order/model/limit-order-id'
import { pairRegistry } from '@root/entities/pair'
import { userOrderEvent } from '@root/entities/realtime'

import { reatomSwapOrder, type SwapOrderModel } from './reatom-swap-order'

import type { TradeSwap } from '@blade/blockchain-types'
import type { TradeApi } from '@root/shared/api'

export class SwapOrderRegistry {
  private registry = new WeakRegistry<string, SwapOrderModel>()

  public constructor() {
    userOrderEvent.onCall((ctx, update) => {
      const order = update.order
      if ('trigger' in order) {
        return
      }
      const orderModel = this.get(LimitOrderId(order.id))
      if (orderModel) {
        orderModel.updateFromDto(ctx, order)
      }
    })
  }

  public get = (id: LimitOrderId) => {
    return this.registry.get(id)
  }
  public getOrCreate = (id: LimitOrderId, factory: () => SwapOrderModel) => {
    return this.registry.getOrCreate(id, factory)
  }
  public resolve = action((ctx, dto: TradeSwap | TradeApi.MarketOrderDto) => {
    if (!dto.pairMeta) {
      // TODO: Support swap orders without pair meta
      return
    }
    const pair = pairRegistry.resolveFromDto(ctx, dto.pairMeta)
    return this.getOrCreate(LimitOrderId(dto.id), () =>
      reatomSwapOrder({ dto, pair }),
    )
  })
  public set = (order: SwapOrderModel) => {
    this.registry.set(order.id, order)
  }
}

export const swapOrderRegistry = new SwapOrderRegistry()
